import React, { ButtonHTMLAttributes, ReactNode } from 'react';

interface AuthButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    children: ReactNode;
    loading?: boolean;
}

export const AuthButton: React.FC<AuthButtonProps> = ({ children, loading, className, ...props }) => {
    return (
        <button
            className={`auth-btn ${className || ''}`}
            disabled={loading}
            {...props}
        >
            {loading ? 'Processing...' : children}
        </button>
    );
};
